/**
 * 国优炬康 管理后台入口
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { permissionDirective } from './directives/permission';
import { useBrandStore } from './stores/brand';
// ElMessage / ElMessageBox 通过 JS 调用,按需自动导入不会注入它们的样式,需手动引入
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import './styles/main.scss';

// 引入 axios-mock-adapter(仅在 VITE_USE_MOCK=true 时注册 mock 路由)
import { setupMock } from './mock';

if (import.meta.env.VITE_USE_MOCK === 'true') {
  setupMock();
}

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.directive('permission', permissionDirective);
app.mount('#app');

// 品牌配置(Logo/标题/主题色)异步拉取,公开端点无需登录;失败保留默认
useBrandStore().fetchBrand();
